module.exports = __webpack_public_path__ + "img/ar12.82c8585d.jpg";